<template>
  <a class="dropdown-item cursor-pointer" @click="handle" v-text="getLabelText"></a>
</template>

<script>
import eventBus from "../../../event-bus";

export default {
  props: {
    message: Object,
    url: String,
  },

  computed: {
    /**
     * @return {String}
     */
    getLabelText() {
      return _.get(this.message, 'is_preserved') ?
          `Unmark as preserved` :
          `Mark as preserved`;
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    handle() {
      axios.post(this.url, {
        id: _.get(this.message, 'id'),
      })
          .then(this.onMessageUpdated)
          .catch(this.onUpdatedError);
    },

    /**
     * @param {Object} data
     * @emits on-message-updated
     * @return {undefined}
     */
    onMessageUpdated({data}) {
      let item = _.get(data, 'data', {});

      eventBus.$emit('on-message-updated', item);

      let message = _.get(data, 'message', null);

      if (!_.isNull(message)) {
        this.$message({
          message: message,
          type: 'success',
        });
      }
    },

    /**
     * @param {Object} response
     * @return {undefined}
     */
    onUpdatedError({response}) {
      this.$message({
        message: _.get(response, 'data.message', 'An error occurred.'),
        type: 'error',
        iconClass: 'el-icon-error',
      });
    },
  },
}
</script>

<style scoped>

</style>
